import React from 'react';
import {entities} from '../../../../../util/uiconstants';
import {labels} from '../../../../../util/utils';
import ManageObjects from './ManageObjectsCommon';
import * as controlActions from '../../../../../actions/Control/controlaction';
import * as risksActions from '../../../../../actions/Risk/riskactions';
import * as relatedObjectsActions from '../../../../../actions/RelatedObjects/relatedobjectsactions';
import * as scotsActions from '../../../../../actions/scots/scotsactions';
import mapResponse from './mapResponseFunctions';

export const documentEntityFormTypes = {
	SCOT_WCGW_CONTROL: `${entities.SCOT}`,
	CONTROL_ITSO_APPLICATIONS: `${entities.Control}`,
	ENGAGEMENT_RISK: `${entities.Engagement}`
};

const handleDuplicateIds = (first, second) => {
	return first.id === second.id && first.entityId === second.entityId;
};

const fetchChildrenData = (page, pageSize, searchString, parentItem) => {
	return parentItem.children;
};

const isEntitySelected = (relatedObjects, element) => {
	const isSelected =
		relatedObjects &&
		relatedObjects.some((relatedObject) => {
			return (
				Number(relatedObject.entityUId) === element.id &&
				relatedObject.entityId === element.entityId &&
				Number(relatedObject.parentEntityUId) === element.parentEntityUId &&
				relatedObject.parentEntityId === element.parentEntityId
			);
		});

	return isSelected;
};

const filterByName = (element, searchString) => {
	return element.name.toLowerCase().includes(searchString.toLowerCase());
};

const onCheckChange = (engagementId, documentId, sectionId, dispatch, item, checked, formSectionRelatedObjectId) => {
	if (checked === true) {
		return dispatch(relatedObjectsActions.relateSectionObject(engagementId, documentId, sectionId, item));
	} else if (checked === false) {
		return dispatch(
			relatedObjectsActions.unrelateSectionObject(engagementId, documentId, sectionId, formSectionRelatedObjectId, item)
		);
	}
};

export const findSectionRelatedObject = (entityId, entityUId, parentEntityId, parentEntityUId, relatedObjects) => {
	return relatedObjects.find((relatedObject) => {
		return (
			relatedObject.entityId === entityId &&
			Number(relatedObject.entityUId) === entityUId &&
			relatedObject.parentEntityId === parentEntityId &&
			Number(relatedObject.parentEntityUId) === parentEntityUId
		);
	}).formSectionRelatedObjectId;
};

const listHeaders = (totalEntityCount, countLabel) => {
	return (
		<ManageObjects.ListHeader
			className={'generic-entity'}
			count={totalEntityCount !== undefined ? totalEntityCount : 0}
			countLabel={countLabel}
		/>
	);
};

const componentHeader = (title) => {
	return <ManageObjects.Header title={title} styleName={'relate-list-checkbox-text'} />;
};

const renderItem = (item, className, noOfLines) => {
	return <ManageObjects.RenderItem item={item} className={`manage-objects-item--${className}`} noOfLines={noOfLines} />;
};

export const getConfigurationForDocumentEntityObject = (documentEntityId) => {
	switch (String(documentEntityId)) {
		case documentEntityFormTypes.SCOT_WCGW_CONTROL: {
			return {
				supportsServerSidePagination: false,
				noResultsLabel: labels.noResultsAvailable,
				noDataLabel: labels.noDocumentScotsAvailable,
				relateListProperties: {
					searchPlaceholder: labels.searchByScotName,
					searchClearHoverText: labels.clearHoverText,
					listHeaders: () => {
						return listHeaders(undefined, '');
					}
				},
				componentHeader: (title) => componentHeader(title),
				render: (item) => renderItem(item, 'scot', 1),
				fetchAction: relatedObjectsActions.getRelatedObjects,
				mapResponse: mapResponse.Scot,
				checkBox: false,
				selected: isEntitySelected,
				filter: filterByName,
				onCheckChange: onCheckChange,
				children: {
					checkBox: true,
					data: scotsActions.getSCOTById,
					mapResponse: mapResponse.WcgwsControls,
					render: (item) => renderItem(item, 'wcgw', 2),
					filter: filterByName,
					selected: isEntitySelected,
					children: {
						checkBox: true,
						data: fetchChildrenData,
						enabledByParent: true,
						render: (item) => renderItem(item, 'control', 3),
						selected: isEntitySelected,
						filter: filterByName
					}
				}
			};
		}
		case documentEntityFormTypes.ENGAGEMENT_RISK: {
			return {
				supportsServerSidePagination: false,
				noResultsLabel: labels.noResultsAvailable,
				noDataLabel: labels.noRisksAvailable,
				relateListProperties: {
					searchPlaceholder: labels.searchByRiskName,
					searchClearHoverText: labels.clearHoverText,
					listHeaders: (totalEntityCount, showing) =>
						listHeaders(showing !== undefined ? showing : totalEntityCount, labels.risksCount)
				},
				componentHeader: (title) => componentHeader(title),
				render: (item) => renderItem(item, 'risk', 2),
				onCheckChange: onCheckChange,
				fetchAction: (url) => {
					return risksActions.getRisks_old(url);
				},
				mapResponse: mapResponse.EngagementRisks,
				checkBox: true,
				selected: isEntitySelected,
				children: null,
				urlRequired: true,
				filter: filterByName
			};
		}
		case documentEntityFormTypes.CONTROL_ITSO_APPLICATIONS: {
			return {
				supportsServerSidePagination: false,
				noResultsLabel: labels.noResultsAvailable,
				noDataLabel: labels.noDocumentControlsAvailable,
				relateListProperties: {
					searchPlaceholder: labels.searchByControlName,
					searchClearHoverText: labels.clearHoverText,
					listHeaders: () => {
						return listHeaders(undefined, '');
					},
					pagination: true
				},
				componentHeader: (title) => componentHeader(title),
				render: (item) => renderItem(item, 'control', 3),
				onCheckChange: onCheckChange,
				fetchAction: relatedObjectsActions.getRelatedObjects,
				mapResponse: mapResponse.Control,
				filter: filterByName,
				checkBox: false,
				children: {
					checkBox: true,
					data: controlActions.getControlById,
					filter: filterByName,
					render: (item) => renderItem(item, 'itappso', 2),
					selected: isEntitySelected,
					mapResponse: mapResponse.ITAPPSO
				}
			};
		}
	}
};
